import { render, staticRenderFns } from "./CountryProfileMobile.vue?vue&type=template&id=e398f7f6&scoped=true&"
import script from "./CountryProfileMobile.vue?vue&type=script&lang=js&"
export * from "./CountryProfileMobile.vue?vue&type=script&lang=js&"
import style0 from "./CountryProfileMobile.vue?vue&type=style&index=0&id=e398f7f6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e398f7f6",
  null
  
)

export default component.exports